import { Dialog } from "primereact/dialog";
import GifProcessing from "../../../images/gif_processing_talma.gif";
import { ProcessingContainer } from "./ModalProcessingTalma.styles";
import "./ModalProcessing.css";
interface Props {
  showProcessing: boolean;
}
export const ModalProcessingTalma = ({ showProcessing = false }: Props) => {
  return (
    <Dialog
      style={{ width: "19rem" }}
      className="img-processing-talma-class"
      showHeader={false}
      visible={showProcessing}
      onHide={() => {}}
      draggable={false}
      resizable={false}
    >
      <ProcessingContainer>
        <img src={GifProcessing} alt="" className="img-processing" />
      </ProcessingContainer>
    </Dialog>
  );
};
